export const Formats = [
  { name: "PDF" },
  { name: "TEX" },
  { name: "Browser" }
];
export const DefaultFormat = Formats[0];


